/**
 * The default person name configuration.
 * Examples: John H. Smith, John Smith, John H., John, Smith, Hank
 */
export const defaultPersonNameConfig = {
    formats: [
        '${givenName} ${middleInitial}. ${familyName}',
        '${givenName} ${familyName}',
        '${givenName} ${middleInitial}.',
        '${givenName}',
        '${familyName}',
        '${middleName}'
    ]
};
//# sourceMappingURL=person-name.js.map